import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { MatDialog } from '@angular/material';
import { FundParameters, Contribution, ContributionSubTypesEnum, Parameter, Employee, PeriodTypeEnum,FinancialReturn, ContributionTypesEnum } from '@akiba/models_bimbo';
import * as moment from 'moment';
import { take, map, first } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { MatSelectChange } from '@angular/material';

@Component({
  selector: 'app-lsf-statement',
  templateUrl: './lsf-statement.component.html',
  styleUrls: ['./lsf-statement.component.scss']
})
export class LsfStatementComponent implements OnInit, OnDestroy {

  //////////////////////////////////////
  permanentSavingParameter: Parameter | null = null;
  shortFundParameter: FundParameters | null = null;
  longFundParameter: FundParameters | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////
  dt = moment();
  minuteReset = this.dt.parseZone().utcOffset();
  monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  /////////////////////////////////////////////////////
  payrollContributionArray = Array<any>();
  ContributionArray = new Array<Contribution>();
  firstContributionTimeFAC : number;
  /////////////////////////////////////////////////////

  /////////////////////////////////////////////////////
  userLongFundLoadedSubscription: Subscription | null = null;
  userShortFundLoadedSubscription: Subscription | null = null;
  userSuraFundLoadedSubscription: Subscription | null = null;
  parametersFundSubscription: Subscription | null = null;
  /////////////////////////////////////////////////////
  totalEmployeePastYears = 0;
  totalEmployeeCurrentYear = 0;
  totalCompanyPastYears = 0;
  totalCompanyCurrentYear = 0;
  totalPastYears = 0;
  totalCurrentYear = 0;
  totalEmployee = 0;
  totalCompany = 0;
  total = 0;
  totalPlusInvestment = 0;
  totalInvestment = 0;
  sura = 0;
  suraYear = 0;
  downloadURLLink: string | null = null;
  companyName = '';
  firstDate = new Date();
  pastYears = Array<any>();
  selectedYear = this.firstDate.getFullYear();
  currentYear = this.firstDate.getFullYear();
  suraShort = 0 ;
  totalShortInvestment = 0 ;

  showMessage = false;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));

  @Input() type: string;

  constructor(
    public logicService: LogicService,
    public dialog: MatDialog,
    private dataService: DataSourceService,
    private breakpointObserver: BreakpointObserver
  ) {

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters;
    const fundParameters = this.logicService.dataManager.parameterDataLoader.fundParameters;

    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;
    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    this.shortFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.shortSavingFund).find(e => e.fundAppliesTo(this.currentEmployee));
    this.longFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.longSavingFund).find(e => e.fundAppliesTo(this.currentEmployee));

  }

  ngOnInit() {

    this.totalEmployeePastYears = 0;
    this.totalEmployeeCurrentYear = 0;
    this.totalCompanyPastYears = 0;
    this.totalCompanyCurrentYear = 0;
    this.totalPastYears = 0;
    this.totalCurrentYear = 0;
    this.totalEmployee = 0;
    this.totalCompany = 0;
    this.total = 0;
    this.totalPlusInvestment = 0;
    this.totalInvestment = 0;
    this.sura = 0;

    if (this.type === 'FAC') {
      this.subscribeShortFunds();
      this.subscribeShortSuraFunds();
    } else if (this.type === 'FAL') {
      this.subscribeLongFunds();
      this.subscribeSuraFunds();
    }

  }

  subscribeShortFunds() {

    let from = 0;
    let to = 32511138825000;

    if (this.shortFundParameter && this.shortFundParameter.fundDates.length) {

      const orderedDates = this.shortFundParameter.fundDates.map(e => e.startDate).sort((a, b) => {
        return a.getTime() - b.getTime();
      });

      if (orderedDates.length) {
        this.firstDate = orderedDates[0];
      }

      const sd = this.shortFundParameter.fundDates.find(d => d.active);

      let fromReset = moment(sd.startDate).startOf('day').add(this.minuteReset, 'minutes').toDate();
      let toReset = moment(sd.endDate).startOf('day').add(this.minuteReset, 'minutes').toDate();
      from = fromReset.getTime();
      to = toReset.getTime();
      this.downloadURLLink = this.shortFundParameter.downloadLink();

      const tempo = this.currentEmployee.funds.filter(f => f.type === 'FAC');

      this.ContributionArray = this.currentEmployee.funds.filter(f => f.type === 'FAC' && f.timeStamp >= from && f.timeStamp <= to);
      this.firstContributionTimeFAC  = this.ContributionArray[0] !== undefined ? this.ContributionArray[0].timeStamp : new Date().getTime();
      
      this.payrollContributionArray = this.groupByMonthYear(this.ContributionArray);

      if (!this.ContributionArray.length || this.totalPeriod <= 0) {
        this.showMessage = true;
      } else {
        this.showMessage = false;
      }

    } else {
      this.showMessage = true;
    }


  }

  subscribeLongFunds() {

    if (this.longFundParameter) {

      this.downloadURLLink = this.longFundParameter.downloadLink();
      this.ContributionArray = this.currentEmployee.funds.filter(e => e.type === 'FAL');
      const r = this.groupByCreatedDate(this.ContributionArray);
      this.payrollContributionArray = this.groupByMonthYear(r);

      if (!this.ContributionArray.length) {
        this.showMessage = true;
      } else {
        this.showMessage = false;
      }

    } else {
      this.showMessage = true;
    }

  }

  async subscribeSuraFunds() {
    let timeYearFrom = new Date( this.selectedYear + '-01-01').getTime(); 
    let timeYearTo = new Date( this.selectedYear+1 + '-01-01').getTime(); 
    let timeYearPrevious = new Date( this.selectedYear-1 + '-01-01').getTime(); 

    let falSuraInt : number = 0;

    const falSura = await this.dataService.loadEmployeeContributions(ContributionTypesEnum.FAL_SURA, this.currentEmployee.workInformation.employeeNumber, timeYearFrom, timeYearTo ).pipe(take(1)).toPromise();
    const falSuraEY = await this.dataService.loadEmployeeContributions('FAL_SURAEY', this.currentEmployee.workInformation.employeeNumber, timeYearFrom, timeYearTo).pipe(first()).toPromise().catch(error => {
      console.log(error);
      return [];
    }); 

    const falSuraEYPrev = await this.dataService.loadEmployeeContributions('FAL_SURAEY', this.currentEmployee.workInformation.employeeNumber, timeYearPrevious, timeYearFrom).pipe(first()).toPromise().catch(error => {
      console.log(error);
      return [];
    });

    const contributionSuraPrevArray = falSuraEYPrev.map((rec: any) => new FinancialReturn(rec));
    const falSuraPrevInt = contributionSuraPrevArray.map(x => x.amount).reduce((p, n) => p + n, 0); 

        // year 
        if ( this.selectedYear === this.currentYear){
          falSuraInt = falSura.map(x => x.amount).reduce((p, n) => p + n, 0);
        }else {
          const contributionSuraArray = falSuraEY.map((rec: any) => new FinancialReturn(rec)).filter(e => e.regDate.getFullYear() === this.selectedYear);
          falSuraInt = contributionSuraArray.map(x => x.amount).reduce((p, n) => p + n, 0); 
          
        }
    this.sura = falSuraInt < 0 ? 0 : falSuraInt;
    this.suraYear = this.sura - falSuraPrevInt ;
    this.totalPlusInvestment = this.total + this.sura;

    //console.log( 'sumafal', this.total , this.totalInvestment , this.sura);
    

  }


  async subscribeShortSuraFunds() {
    // agregar en los modelos ContributionTypesEnum.FAC_SURA
//console.log('fac', await this.dataService.loadEmployeeContributions('FAC_SURA', this.currentEmployee.workInformation.employeeNumber).pipe(take(1)).toPromise());

    const facSura = (await this.dataService.loadEmployeeContributions('FAC_SURA', this.currentEmployee.workInformation.employeeNumber).pipe(take(1)).toPromise()).filter(x => x.timeStamp > this.firstContributionTimeFAC);
    const suraInt = facSura.map(x => x.amount).reduce((p, n) => p + n, 0);
    this.suraShort = suraInt < 0 ? 0 : suraInt;
    this.totalShortInvestment = this.totalPeriod + this.suraShort;
  }

  groupByMonthYear(pc: Array<Contribution>): Array<any> {

    const group: any = {};
    pc.forEach((element: Contribution) => {

      const year = element.regDate.getFullYear().toString();
      const month = this.monthNames[element.regDate.getMonth()];
      const displayDate = month + ' ' + year;

      if (group.hasOwnProperty(displayDate)) {

        group[displayDate].employeeAmount = group[displayDate].employeeAmount + element.employeeAmount;
        group[displayDate].companyAmount = group[displayDate].companyAmount + element.companyAmount;
        group[displayDate].employeeWithdraw = group[displayDate].employeeWithdraw + element.employeeWithdraw + element.employeeSettlement;
        group[displayDate].companyWithdraw = group[displayDate].companyWithdraw + element.companyWithdraw + element.companySettlement;

      } else {

        group[displayDate] = {
          date: displayDate,
          employeeAmount: element.employeeAmount,
          companyAmount: element.companyAmount,
          employeeWithdraw: element.employeeWithdraw + element.employeeSettlement,
          companyWithdraw: element.companyWithdraw + element.companySettlement
        };

      }

    });

    const array = new Array<any>();
    Object.keys(group).forEach(d => {
      array.push(group[d]);
    });

    return array;

  }

  groupByCreatedDate(pc: Array<Contribution>): Array<Contribution> {

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentYearArray = new Array<Contribution>();
    this.totalEmployeePastYears = 0;
    this.totalCompanyPastYears = 0;
    this.totalPastYears = 0;
    this.totalEmployeeCurrentYear = 0;
    this.totalCompanyCurrentYear = 0;
    this.totalEmployee = 0;
    this.totalCompany = 0;
    this.total = 0;
    this.totalInvestment = 0;
    const years = [this.currentYear];

    pc.forEach((element: Contribution) => {

      const year = element.regDate.getFullYear();

      if (element.investmentReturn < 0 && element.subType === ContributionSubTypesEnum.FAL_AL) {
        element.investmentReturn = 0;
 
      }

      if(year > 2020){
        years.push(year);
      }
  

      if (year < this.selectedYear) {

        this.totalEmployeePastYears += element.employeeAmount;
        this.totalEmployeePastYears += element.employeeSettlement;
        this.totalEmployeePastYears += element.employeeWithdraw;

        this.totalCompanyPastYears += element.companyAmount;
        this.totalCompanyPastYears += element.companySettlement;
        this.totalCompanyPastYears += element.companyWithdraw;

        this.totalPastYears = this.totalEmployeePastYears + this.totalCompanyPastYears;

      } else if (year === this.selectedYear ) {

        currentYearArray.push(element);

        this.totalEmployeeCurrentYear += element.employeeAmount;
        this.totalEmployeeCurrentYear += element.employeeSettlement;
        this.totalEmployeeCurrentYear += element.employeeWithdraw;

        this.totalCompanyCurrentYear += element.companyAmount;
        this.totalCompanyCurrentYear += element.companySettlement;
        this.totalCompanyCurrentYear += element.companyWithdraw;

      }

      this.totalEmployee = this.totalEmployeePastYears + this.totalEmployeeCurrentYear;
      this.totalCompany = this.totalCompanyPastYears +  this.totalCompanyCurrentYear;
      this.total = Number((this.totalEmployee + this.totalCompany).toFixed(2));
      this.totalInvestment += element.investmentReturn;

    });

    const dataArr = new Set(years);
    this.pastYears = Array.from(dataArr) ;

    return currentYearArray;

  }

  get currentPeriodDates(): string {

    let from = 0;
    let to = 0;

    if (this.type === 'FAL') {

      const aDate = new Date();
      return String(aDate.getFullYear());

    } else {

      if (this.shortFundParameter) {

        const sd = this.shortFundParameter.fundDates.find(d => d.active);
        from = sd.startDate.getFullYear();
        to = sd.endDate.getFullYear();
        if (from === to) {
          return String(from);
        }
        return String(from) + ' - ' + String(to);

      } else {
        const today = new Date();
        return String(today.getFullYear());
      }

    }

  }

  get periodTotalEmployee(): number {
    const today = new Date();
    if (this.ContributionArray.length) {
      return this.ContributionArray.map((element: Contribution) => element.employeeAmount).reduce(((prev, next) => {
        if (next) {
          return prev + next;
        }
        return prev;
      }), 0);
    }
    return 0;
  }

  get periodTotalCompany(): number {

    if (this.ContributionArray.length) {
      return this.ContributionArray.map((element: any) => element.companyAmount).reduce(((prev, next) => {
        if (next) {
          return prev + next;
        }
        return prev;
      }), 0);
    }
    return 0;
  }

  get totalPeriod(): number {
    return this.periodTotalCompany + this.periodTotalEmployee;
  }


  get shouldShowPast(): boolean {
    const today = moment();
    const fDay = moment(this.firstDate);
    const future = fDay.add(21, 'day');
    if (today.isAfter(future)) {
      return false;
    }
    return true;
  }

  selectedPeriodChange(event: MatSelectChange) {

      if (!event.value) {
        let dateYear = new Date();
      this.selectedYear = dateYear.getFullYear();
    } else {

      this.selectedYear = event.value;
      const r = this.groupByCreatedDate(this.ContributionArray);
      this.payrollContributionArray = this.groupByMonthYear(r);
      this.subscribeSuraFunds();

    }

  }

  ngOnDestroy() {

    if (this.parametersFundSubscription && !this.parametersFundSubscription.closed) {
      this.parametersFundSubscription.unsubscribe();
      this.parametersFundSubscription = null;
    }

    if (this.userLongFundLoadedSubscription && !this.userLongFundLoadedSubscription.closed) {
      this.userLongFundLoadedSubscription.unsubscribe();
      this.userLongFundLoadedSubscription = null;
    }

    if (this.userShortFundLoadedSubscription && !this.userShortFundLoadedSubscription.closed) {
      this.userShortFundLoadedSubscription.unsubscribe();
      this.userShortFundLoadedSubscription = null;
    }

    if (this.userSuraFundLoadedSubscription && !this.userSuraFundLoadedSubscription.closed) {
      this.userSuraFundLoadedSubscription.unsubscribe();
      this.userSuraFundLoadedSubscription = null;
    }

  }

}
